/**
 * @description 會員資料維護頁切換用
*/
export enum MemberMaintainStep {
  /** 會員資料維護頁 */
  MemberMaintain = 1,
  /** OTP 驗證頁 */
  OTPVerification = 2,
  /** 會員資料修改完成 */
  MaintainComplete = 3
}
